var ServerError = /** @class */ (function () {
    function ServerError(type, message, action) {
        this.type = type;
        this.message = message;
        this.action = action;
    }
    return ServerError;
}());
export { ServerError };
